import { Stores } from '@bee-hole/api';
import { AgnosticStore, UseStoreGetters } from '@vue-storefront/core';
import { UseStoreFilterParams } from '../types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getItems(stores: Stores, criteria: UseStoreFilterParams): AgnosticStore[] {
  return [];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getSelected(stores: Stores): AgnosticStore | undefined {
  return null;
}

export const storeGetters: UseStoreGetters<Stores, UseStoreFilterParams> = {
  getItems,
  getSelected
};
